import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";

import DeleteIcon from "@material-ui/icons/Delete"
import IconButton from "@material-ui/core/IconButton";
import {Typography} from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import Paper from "@material-ui/core/Paper";
import _ from "lodash";
import Card from "@material-ui/core/Card";
import ThumbnailUploader from "./ThumbnailUploader";

const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    formControl: {},
    titleInput: {},
    timeInput: {},
    button: {

        marginTop: theme.spacing(3),
    },
    momentClipIdContainer: {
        marginTop: theme.spacing(4),
    },
    thumbnailContainer:{
        display:"inline-block"
        
    },
    thumbnailImage:{
        height:"45px",
        width:"80px",
        marginRight:theme.spacing(1),
        marginTop:theme.spacing(1)
    }
}));


export default function MomentClipInput(props) {
    let isThumbnailUploadVisible= false


    const classes = useStyles();

    const [values, setValues] = React.useState(props.moment);

    React.useEffect(() => {
        setValues(props.moment)
    }, [props.moment]);

    const handleChange = name => event => {
        setValues({...values, [name]: event.target.value});
    };

    const handleSave = (event) => {
        event.preventDefault();
        props.handleSave(values);
    };

    const updateThumbnails = (url) => {
        let thumbnails = values.thumbnails;
        let thumbnailToAdd = {
            "contentType": "MOMENT_CLIP",
            "sourceUrl": url,
            "aspectRatio": "4x3"
        };
        if (thumbnails && thumbnails.length > 0) {
            thumbnails.push(thumbnailToAdd);
        } else {
            thumbnails = [];
            thumbnails[0] = thumbnailToAdd;
        }

        setValues({...values, thumbnails: thumbnails});
    };

    return (

        <form className={classes.container} onSubmit={handleSave.bind(this)} autoComplete="off">

            <Grid container direction="row" alignItems="center"
                  justify="center" spacing={1}>
                <Grid item xs={1}>
                    {values.id &&
                    <Typography className={classes.momentClipIdContainer} variant={"body1"}>ID: {values.id}</Typography>
                    }
                </Grid>

                <Grid item xs={2}>

                    <>
                        <div className={classes.thumbnailContainer}>
                        {values.thumbnails && values.thumbnails.length > 0 &&
                        _.map(values.thumbnails, (thumbnail, index) => {
                            if (thumbnail.id) {
                                return (<span key={index}>
                                    <a href={thumbnail.sourceUrl.replace("http://ctool0.blueapple.mobi:8099/","https://storage.googleapis.com/lcontent.vuclip.com/")}
                                       target="_blank" rel="noopener noreferrer">
                                        <img src={thumbnail.sourceUrl.replace("http://ctool0.blueapple.mobi:8099/","https://storage.googleapis.com/lcontent.vuclip.com/")} className={classes.thumbnailImage}></img>
                                    </a>
                                </span>)
                            }

                        })
                        }
                        </div>
                        {isThumbnailUploadVisible && <ThumbnailUploader updateThumbnails={updateThumbnails.bind(this)} label={'Upload thumbnails'}
                                                                        files={values.thumbnails} type={'momentClips'} inputName={'MOMENT_CLIP16x9'}/>}
                    </>
                </Grid>

                <Grid item xs={3}>
                    <TextField fullWidth
                               id="title" required
                               label="Clip Moment Title"
                               className={classes.titleInput}
                               onChange={handleChange('title')}
                               value={values.title}
                               margin="normal"
                    />
                </Grid>


                <Grid item xs={1}>
                    <TextField fullWidth
                               id="start-time" required
                               label="Start Time"
                               className={classes.timeInput}
                               value={values.startTime}
                               onChange={handleChange('startTime')}
                               placeholder={"HH:mm:ss"}
                               inputProps={{
                                   'pattern': '^(?:(?:([01]?\\d|2[0-3]):)?([0-5]?\\d):)?([0-5]?\\d)$',
                                   'title': 'Start time should be of HH:mm:ss format'
                               }}
                               margin="normal"
                    />
                </Grid>


                <Grid item xs={1}>
                    <TextField fullWidth required
                               id="end-time"
                               label="End Time"
                               className={classes.timeInput}
                               value={values.endTime}
                               placeholder={"HH:mm:ss"}
                               inputProps={{
                                   'pattern': '^(?:(?:([01]?\\d|2[0-3]):)?([0-5]?\\d):)?([0-5]?\\d)$',
                                   'title': 'End time should be of HH:mm:ss format'
                               }}
                               onChange={handleChange('endTime')}
                               margin="normal"
                    />
                </Grid>

                <Grid item xs={2}>
                    <TextField fullWidth
                               id="tags"
                               label="Tags"
                               placeholder={"e.g. fun,comedy"}
                               className={classes.titleInput}
                               onChange={handleChange('tags')}
                               value={values.tags}
                               margin="normal"
                    />
                </Grid>


                <Grid item xs={1}>
                    <Button variant="contained" type="submit" color="primary" className={classes.button}>
                        Save
                    </Button>

                </Grid>
                <Grid item xs={1}>
                    <Tooltip title="Delete Clip Moment" aria-label="delete clip moment">
                        <IconButton onClick={props.handleDelete.bind(this, values, props.index)} aria-label="delete"
                                    className={classes.button}>
                            <DeleteIcon fontSize="small"/>
                        </IconButton>
                    </Tooltip>
                </Grid>

            </Grid>
            <br/>
        </form>

    );
}